import { defineAsyncComponent } from 'vue';
import type { ModularBlockConfig } from '../../../frontend/types';
import { blockStepsSectionFields } from './groq';

/**
 * Shared registry entry — apps compose into their own `modularBlocksConfig`.
 *
 * Lazy per the block-loading rule: every block is code-split. The block's HTML
 * is still server-rendered (Suspense resolves async components during SSR), so
 * first paint is unaffected — only hydration waits on this chunk.
 */
export const stepsSectionBlockConfig = {
  name: 'outer-block-steps-section',
  component: defineAsyncComponent(() => import('./CmsStepsSectionBlock.vue')),
  innerComponent: defineAsyncComponent(() => import('./StepsSection.vue')),
  fields: blockStepsSectionFields,
} satisfies ModularBlockConfig;
